import {Nav, Tab} from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import ProfileBanner from "../../components/Profile/Banner";
import {Link, useLocation} from "react-router-dom";
import ProfileForm from "../../components/Profile/profileForm";
import ProfileDiplomes from "../../components/Profile/profileDiplome";
import ProfileZones from "../../components/Profile/ProfileZones";
import ProfileExpertise from "../../components/Profile/profileExpertise";
import {useEffect, useState} from "react";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../../components/shared/Loader";
import {accountStatus, userRoleList} from "../../../utils/constants";
import AllReviewTable from "../../components/Dashboard/acara/dashboardTable/Reviews/AllReviewTable";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import ListReviews from "../../components/Profile/ListReviews";
import ModifProfileZones from "../../components/Profile/ModifProfileZones";
import ModifProfileExpertise from "../../components/Profile/ModifProfileExpertise";
import Bio from "../../components/Profile/Bio";
import QueryErrorState from "../../components/shared/QueryErrorState";
import {getDateLocale} from "../../../utils/date";
import RealizationGallery from "../../components/Profile/RealizationGallery";

const ProfilePage = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Presentation");
  const {data, isLoading, isError, error, refetch} = useMe();
  const {onVerifyEmail} = useUpdateTechnician();

  const verifEmail = () => {
    onVerifyEmail({email: data.email});
  };

  useEffect(() => {
    if (
      location.hash.includes("#avis") ||
      data?.selectedRole === userRoleList.CLIENT
    ) {
      setActiveTab("avis");
    }
  }, [location, data]);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  const {
    selectedRole,
    phone,
    email,
    reviews,
    address,
    zipCode,
    city,
    Technician,
  } = data;
  // const {address, zipCode, city} = data?.Technician || data?.Client;
  return (
    <>
      {/* <PageTitle activeMenu="Mon profil" /> */}
      <div className="w-full flex flex-col px-1 lg:grid lg:grid-cols-4 gap-4">
        <ProfileBanner />
        <div className="col-span-3 w-full bg-white !py-5 !px-6 rounded-xl">
          <div className="profile-tab">
            <div className="custom-tab-1">
              <Tab.Container
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
              >
                <Nav as="ul" className="nav nav-tabs">
                  {selectedRole === userRoleList.TECHNICIAN && (
                    <>
                      <Nav.Item as="li" role="presentation" className="nav-item">
                        <Nav.Link eventKey="Presentation">BIO</Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" role="presentation" className="nav-item">
                        <Nav.Link eventKey="Expertises">Compétences</Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" role="presentation" className="nav-item">
                        <Nav.Link eventKey="Zones">
                          Zones d’intervention
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" role="presentation" className="nav-item">
                        <Nav.Link eventKey="Realizations">Réalisations</Nav.Link>
                      </Nav.Item>
                    </>
                  )}
                  <Nav.Item as="li" role="presentation" className="nav-item">
                    <Nav.Link eventKey="avis">Évaluations</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="avis">
                    <div className="w-full px-1 py-11 flex flex-col gap-5 justify-start items-start">
                      <div className="text-left font-bold text-xl text-[#19295C]  ">
                        Liste des évaluations
                      </div>
                      {!!reviews?.length ? (
                        <ListReviews reviews={reviews} />
                      ) : (
                        <div className="text-base text-[#7e7e7e]">
                          Pas d'évaluations
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                  {selectedRole === userRoleList.TECHNICIAN && (
                    <>
                      <Tab.Pane eventKey="Presentation">
                        {/* <div className="w-full px-1 py-11 flex flex-col gap-5 justify-start items-start">
                          <div className="text-left font-bold text-xl text-[#19295C]  ">
                            Présentation
                          </div>
                          {!data?.Technician?.bio ? (
                            <div className="text-base text-[#7e7e7e]">
                              Pas de présentation.
                            </div>
                          ) : (
                            <p className="text-[#333333] text-[15px] font-medium text-left ">
                              {data?.Technician?.bio}
                            </p>
                          )}
                        </div> */}
                        <Bio
                          bio={data?.Technician?.bio ?? ""}
                          techId={data?.Technician?.id}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Zones">
                        {/* <ProfileZones isActive={activeTab === "Zones"} /> */}
                        <ModifProfileZones isActive={activeTab === "Zones"} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Expertises">
                        {/* <ProfileExpertise /> */}
                        <ModifProfileExpertise />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Realizations">
                        <div className="w-full px-1 py-8">
                          <RealizationGallery
                            editable
                            files={data?.Technician?.FileUploads || []}
                            technicianId={data?.Technician?.id}
                            onChanged={refetch}
                          />
                        </div>
                      </Tab.Pane>
                    </>
                  )}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-start items-start gap-3">
          <div className="w-full bg-white !rounded-lg flex gap-3 flex-col 2xl:!px-4 px-4 lg:!px-3 !py-4 ">
            <div className="text-left font-bold text-base text-[#19295C] mb-1 ">
              Mes Coordonnées
            </div>
            <div className="w-full flex justify-start items-center gap-2">
              <span className="text-base text-[#0022AA]">
                <i className="fi fi-rr-phone-call flex items-center"></i>
              </span>
              <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                {phone ?? "--"}
              </span>
            </div>
            <div className="w-full flex justify-start items-start gap-2  ">
              <span className="text-base text-[#0022AA] ">
                <i className="fi fi-rr-envelope flex items-center"></i>
              </span>
              <span
                title={email}
                className="font-semibold text-[13px] leading-4 text-[#7e7e7e] break-all "
              >
                {email ?? "--"}
              </span>
            </div>
            <div className="w-full flex justify-start items-start gap-2">
              <span className="text-base text-[#0022AA]">
                <i className="fi fi-rr-marker flex items-center"></i>
              </span>
              <span
                className="font-semibold text-[13px] flex-grow leading-4 text-[#7e7e7e] text-wrap  break-all "
                title={`${address} ${zipCode}`}
              >
                {!!address ? (
                  `${address} ,${zipCode} `
                ) : (
                  <div className="flex flex-nowrap justify-between w-full">
                    <span>-- </span>
                    <Link
                      to={"/mon-compte"}
                      className=" text-xs flex gap-1 text-[#FF0000] hover:underline hover:text-[#FF0000]"
                    >
                      {" "}
                      <span className="underline">Complétez l'address </span>
                      <i className="fi fi-ss-circle-xmark flex items-center"></i>
                    </Link>
                  </div>
                )}
              </span>
            </div>
          </div>
          <div className="w-full bg-white !rounded-lg flex gap-3 flex-col 2xl:!px-4 px-4 lg:!px-3 !py-4 ">
            <div className="text-left font-bold text-base  text-[#19295C] mb-1 ">
              Vérifications
            </div>
            {data.selectedRole === userRoleList.TECHNICIAN && (
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                  Pièce d’identité
                </span>

                {data?.Technician?.status === accountStatus.VALID ? (
                  <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                    <span className="text-xs">Vérifiée </span>
                    <i className="fi fi-ss-check-circle flex items-center"></i>
                  </div>
                ) : (
                  <div className="flex gap-1 text-[#FF0000] font-semibold text-xs ">
                    <span className="text-xs">Non Vérifiée </span>
                    <i className="fi fi-ss-circle-xmark flex items-center"></i>
                  </div>
                )}
              </div>
            )}

            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                Adresse mail
              </span>

              {!!data?.verifiedEmail ? (
                <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                  <span className="text-xs">Vérifiée </span>
                  <i className="fi fi-ss-check-circle flex items-center"></i>
                </div>
              ) : (
                <button
                  type="button"
                  className="flex gap-1 text-[#FF0000] font-semibold text-xs cursor-pointer"
                  onClick={verifEmail}
                >
                  <span className="text-xs underline">Vérifiez l'email </span>
                  <i className="fi fi-ss-circle-xmark flex items-center"></i>
                </button>
              )}
            </div>
            <div className="w-full flex justify-between items-center">
              <span className="font-semibold text-[13px] leading-4 text-[#7e7e7e] ">
                Numéro de téléphone
              </span>

              <div className="flex gap-1 text-[#27AA00] font-semibold text-xs">
                <span className="text-xs">Vérifié </span>
                <i className="fi fi-ss-check-circle flex items-center"></i>
              </div>
            </div>
          </div>

          {selectedRole === userRoleList.TECHNICIAN && (
            <div className="w-full bg-white !rounded-lg flex gap-3 flex-col 2xl:!px-4 px-4 lg:!px-3 !py-4 ">
              <div className="text-left font-bold text-base text-[#19295C] mb-1 ">
                Statistiques
              </div>
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px]  leading-4 text-[#7e7e7e] ">
                  Interventions réalisées
                </span>

                <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[13px]  leading-4">
                  {Technician?.interventionCount ?? 0}
                </div>
              </div>
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px]  leading-4 text-[#7e7e7e] ">
                  Interventions réussies
                </span>

                <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[13px]  leading-4">
                  {Technician?.missionCount && Technician?.interventionCount
                    ? `${Math.round(
                        (Technician.missionCount /
                          Technician.interventionCount) *
                          100
                      )}%`
                    : "--"}
                </div>
              </div>
              <div className="w-full flex justify-between items-center">
                <span className="font-semibold text-[13px]  leading-4 text-[#7e7e7e] ">
                  Membre depuis
                </span>

                <div className="flex justify-end gap-1 text-[#19295C] font-semibold text-[13px]  leading-4">
                  {new Date(data?.createdAt)
                    .toLocaleDateString(getDateLocale(), {
                      month: "short",
                      year: "numeric",
                    })
                    .replace(".", "")}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
